module.exports = __webpack_public_path__ + "static/media/tufin.4aaeaceb.png";